import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Crop from 'react-easy-crop';
import { useTranslation } from 'react-i18next';

import Button from '../Button';
import Modal from '../Modal';
import Range from '../Range';

import s from './ImageCrop.module.css';

const OPAQUE_BACKGROUND =
  "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAK0lEQVQ4y2P8//8/A25w7949PLJMDBSAUc0jQzML/jSkpKQ0GmCjminRDADJNQjBr5nbigAAAABJRU5ErkJggg==')";

const ImageCrop = ({ isOpen, onFinish: callback, aspectRatio, image, round }) => {
  const [t] = useTranslation();

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [viewport, setViewport] = useState();
  const [imageSize, setImageSize] = useState();

  const [zoom, setZoom] = useState([1]);
  const minZoom = [0.02];
  const maxZoom = [3];

  const onFinish = () => {
    callback({ ...viewport, ...imageSize });
  };

  return (
    <Modal isOpen={isOpen} onClose={onFinish}>
      <div className={s.root}>
        <div className={s.header}>{t('Выбранная область будет использована для изображения')}</div>
        <div className={s.viewport}>
          <Crop
            style={{ containerStyle: { background: OPAQUE_BACKGROUND } }}
            onCropChange={setCrop}
            onCropComplete={(_, vp) => setViewport(vp)}
            onMediaLoaded={({ naturalWidth, naturalHeight }) => setImageSize({ naturalWidth, naturalHeight })}
            className={s.root}
            image={image}
            crop={crop}
            zoom={zoom}
            minZoom={minZoom}
            showGrid
            restrictPosition={false}
            cropShape={round ? 'round' : 'rect'}
            aspect={aspectRatio}
          />
        </div>
        <div className={s.settings}>
          <div className={s.range}>
            <div className={s.label}>{t('Масштаб')}</div>
            <Range values={zoom} min={minZoom[0]} max={maxZoom[0]} onChange={values => setZoom(values)} />
          </div>

          <Button fixedWidth={185} center onClick={onFinish}>
            {t('Готово')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ImageCrop.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  round: PropTypes.bool,
};

ImageCrop.defaultProps = {
  round: false,
};

export default ImageCrop;
